import React from 'react'

/** Painel direito decorativo (layout tipo split-screen), tema Zap+ */
export function AuthPromoPanel() {
  return (
    <div className="auth-split__promo">
      <div className="auth-split__promo-cards">
        <div className="auth-split__mock-card auth-split__mock-card--chart">
          <p className="auth-split__mock-title">Envios na semana</p>
          <svg
            className="auth-split__mock-svg"
            viewBox="0 0 280 100"
            preserveAspectRatio="none"
            aria-hidden
          >
            <defs>
              <linearGradient id="authChartGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#7b2cbf" stopOpacity="0.45" />
                <stop offset="100%" stopColor="#7b2cbf" stopOpacity="0" />
              </linearGradient>
            </defs>
            <path
              fill="url(#authChartGrad)"
              d="M0,85 L40,72 L80,78 L120,45 L160,55 L200,28 L240,38 L280,22 L280,100 L0,100 Z"
            />
            <polyline
              fill="none"
              stroke="#7b2cbf"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="0,85 40,72 80,78 120,45 160,55 200,28 240,38 280,22"
            />
          </svg>
          <div className="auth-split__mock-meta">
            <span className="auth-split__mock-stat">+24%</span>
            <span className="auth-split__mock-caption">vs. semana anterior</span>
          </div>
        </div>

        <div className="auth-split__mock-card auth-split__mock-card--bars">
          <p className="auth-split__mock-title">Canais em uso</p>
          <div className="auth-split__bar-track" aria-hidden>
            <span
              className="auth-split__bar-seg"
              style={{ width: '58%', background: '#7b2cbf' }}
            />
            <span
              className="auth-split__bar-seg"
              style={{ width: '22%', background: '#22c55e' }}
            />
            <span
              className="auth-split__bar-seg"
              style={{ width: '20%', background: '#38bdf8' }}
            />
          </div>
          <ul className="auth-split__mock-legend">
            <li>
              <span className="auth-split__dot" style={{ background: '#7b2cbf' }} />
              WhatsApp 58%
            </li>
            <li>
              <span className="auth-split__dot" style={{ background: '#22c55e' }} />
              SMS 22%
            </li>
            <li>
              <span className="auth-split__dot" style={{ background: '#38bdf8' }} />
              Outros 20%
            </li>
          </ul>
        </div>
      </div>

      <h2 className="auth-split__promo-heading">Decisões com dados.</h2>
      <p className="auth-split__promo-text">
        Acompanhe campanhas, listas e entregas em um só lugar — com o mesmo
        contraste e clareza que você espera do painel Zap+.
      </p>

      <div className="auth-split__dots" aria-hidden>
        <span className="is-active" />
        <span />
        <span />
      </div>
    </div>
  )
}
